// import React, { useEffect, useState, useMemo, useRef } from "react";
// import { useParams } from "react-router-dom";
// import { useForms } from "../../contexts/FormsContext";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import axios from "axios";
// import Notification from "../../components/UI/Notification";
// // import { getToken } from "../../utils/tokenUtils";

// const FormRender = React.memo(() => {
//     const { id } = useParams();
//     const { forms, fetchForms, loading, error } = useForms();
//     const [form, setForm] = useState(null);
//     const [responses, setResponses] = useState({});
//     const [notification, setNotification] = useState(null);
//     const formRef = useRef(null);

//     // const token = getToken();

//     // Fetch and initialize form
//     useEffect(() => {
//         const loadForm = async () => {
//             const existingForm = forms.find((form) => form.id === parseInt(id, 10));
//             if (existingForm) {
//                 processForm(existingForm);
//             } else {
//                 await fetchForms();
//                 const fetchedForm = forms.find((form) => form.id === parseInt(id, 10));
//                 if (fetchedForm) {
//                     processForm(fetchedForm);
//                 }
//             }
//         };
//         loadForm();
//     }, [id, forms, fetchForms]);

//     // Process form and initialize responses
//     const processForm = (rawForm) => {
//         const updatedFields = rawForm.fields.map((field, index) => ({
//             id: index + 1,
//             field_name: field.field_name,
//             type: field.field_type,
//             placeholder: field.placeholder,
//             options: field.options || [],
//             required: field.required || false,
//             maxRating: field.maxRating || 5, // For rating
//             min: field.min || 0, // For sliders
//             max: field.max || 100, // For sliders
//             step: field.step || 1, // For sliders
//         }));
//         setForm({ ...rawForm, fields: updatedFields });
//         initializeResponses(updatedFields);
//     };

//     const initializeResponses = (fields) => {
//         const initialResponses = fields.reduce((acc, field) => {
//             acc[field.id] = field.type === "checkboxes" ? [] : "";
//             return acc;
//         }, {});
//         setResponses(initialResponses);
//     };

//     const updateFieldResponse = (fieldId, value) => {
//         setResponses((prevResponses) => ({
//             ...prevResponses,
//             [fieldId]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const formData = new FormData();
//         // console.log("form data", formData)
//         formData.append("form_id", form.id);
//         formData.append("form_name", form.form_name);

//         form.fields.forEach((field) => {
//             const response = responses[field.id];
//             if (field.type === "file-upload" && response instanceof File) {
//                 formData.append(field.field_name, response);
//             } else {
//                 formData.append(field.field_name, response || "");
//             }
//         });

//         try {
//             const response = await axios.post("https://hrmsnew.prepstripe.com/api/form-submit", formData, {
//                 headers: {
//                     "Content-Type": "multipart/form-data",
//                 },
//             });
//             // console.log("form submitted")
//             // console.log(response)
//             setNotification("Form submitted successfully!");
//             // Reset form responses
//             initializeResponses(form.fields);
//             // reset file field as well
//             formRef.current.reset();
//         } catch (error) {
//             setNotification("Failed to submit the form. Please try again.");
//         }
//     };

//     // Render inputs dynamically based on field type
//     const renderFieldInput = (field) => {
//         switch (field.type) {
//             case "short-answer":
//                 return (
//                     <input
//                         type="text"
//                         value={responses[field.id] || ""}
//                         placeholder={field.placeholder || "Enter text"}
//                         className="w-full p-2 border rounded"
//                         required
//                         onChange={(e) => updateFieldResponse(field.id, e.target.value)}
//                     />
//                 );
//             case "long-answer":
//                 return (
//                     <textarea
//                         value={responses[field.id] || ""}
//                         placeholder={field.placeholder || "Enter detailed response"}
//                         className="w-full p-2 border rounded"
//                         rows="4"
//                         required
//                         onChange={(e) => updateFieldResponse(field.id, e.target.value)}
//                     />
//                 );
//             case "radio-button":
//                 return (
//                     <div>
//                         {field.options.map((option, idx) => (
//                             <div key={`${field.id}-radio-${idx}`} className="flex items-center gap-2">
//                                 <input
//                                     type="radio"
//                                     name={`radio-${field.id}`}
//                                     value={option}
//                                     required
//                                     checked={responses[field.id] === option}
//                                     onChange={() => updateFieldResponse(field.id, option)}
//                                 />
//                                 <label>{option}</label>
//                             </div>
//                         ))}
//                     </div>
//                 );
//             case "checkboxes":
//                 return (
//                     <div>
//                         {field.options.map((option, idx) => (
//                             <div key={`${field.id}-checkbox-${idx}`} className="flex items-center gap-2">
//                                 <input
//                                     type="checkbox"
//                                     value={option}
//                                     required
//                                     checked={responses[field.id]?.includes(option) || false}
//                                     onChange={(e) => {
//                                         const updatedSelections = e.target.checked
//                                             ? [...responses[field.id], option]
//                                             : responses[field.id].filter((opt) => opt !== option);
//                                         updateFieldResponse(field.id, updatedSelections);
//                                     }}
//                                 />
//                                 <label>{option}</label>
//                             </div>
//                         ))}
//                     </div>
//                 );
//             case "dropdown":
//                 return (
//                     <select
//                         value={responses[field.id] || ""}
//                         className="w-full p-2 border rounded"
//                         onChange={(e) => updateFieldResponse(field.id, e.target.value)}
//                         required
//                         >
//                         <option value="" disabled>
//                             Select an option
//                         </option>
//                         {field.options.map((option, idx) => (
//                             <option key={`${field.id}-dropdown-${idx}`} value={option}>
//                                 {option}
//                             </option>
//                         ))}
//                     </select>
//                 );
//             case "date":
//                 return (
//                     <input
//                         type="date"
//                         value={responses[field.id] || ""}
//                         className="w-full p-2 border rounded"
//                         onChange={(e) => updateFieldResponse(field.id, e.target.value)}
//                         required
//                     />
//                 );
//             case "date-time":
//                 return (
//                     <input
//                         type="datetime-local"
//                         value={responses[field.id] || ""}
//                         className="w-full p-2 border rounded"
//                         onChange={(e) => updateFieldResponse(field.id, e.target.value)}
//                         required
//                     />
//                 );
//             case "file-upload":
//                 return (
//                     <input
//                         type="file"
//                         className="w-full p-2 border rounded"
//                         onChange={(e) => updateFieldResponse(field.id, e.target.files[0])}
//                         required
//                     />
//                 );
//             case "rating":
//                 return (
//                     <div className="flex gap-2">
//                         {[...Array(field.maxRating || 5)].map((_, idx) => (
//                             <span
//                                 key={`${field.id}-rating-${idx}`}
//                                 className={`cursor-pointer ${(responses[field.id] || 0) > idx ? "text-yellow-500" : "text-gray-300"
//                                     }`}
//                                 onClick={() => updateFieldResponse(field.id, idx + 1)}
//                                 required
//                             >
//                                 ★
//                             </span>
//                         ))}
//                     </div>
//                 );
//             case "toggle":
//                 return (
//                     <label className="flex items-center gap-2">
//                         <input
//                             type="checkbox"
//                             checked={responses[field.id] || false}
//                             onChange={(e) => updateFieldResponse(field.id, e.target.checked)}
//                             required
//                         />
//                         <span>{field.field_name}</span>
//                     </label>
//                 );
//             case "slider":
//                 return (
//                     <input
//                         type="range"
//                         min={field.min}
//                         max={field.max}
//                         step={field.step}
//                         value={responses[field.id] || field.min}
//                         onChange={(e) => updateFieldResponse(field.id, parseInt(e.target.value, 10))}
//                         required
//                         className="w-full"
//                     />
//                 );
//             case "color-picker":
//                 return (
//                     <input
//                         type="color"
//                         value={responses[field.id] || "#000000"}
//                         onChange={(e) => updateFieldResponse(field.id, e.target.value)}
//                         required
//                         className="w-12 h-12"
//                     />
//                 );
//             case "section":
//                 return (
//                     <div className="bg-gray-100 p-4 rounded">
//                         <h2 className="text-lg font-bold">{field.field_name}</h2>
//                     </div>
//                 );
//             default:
//                 return <p className="text-red-500">Unsupported field type: {field.type}</p>;
//         }
//     };

//     const memoizedFields = useMemo(() => {
//         return form?.fields.map((field) => (
//             <div key={field.id} className="p-4 bg-white rounded shadow">
//                 <label className="block font-semibold mb-2">{field.field_name}</label>
//                 {renderFieldInput(field)}
//             </div>
//         ));
//     }, [form, responses]);

//     if (loading) {
//         return (
//             <div className="p-6">
//                 <Skeleton height={40} count={5} />
//             </div>
//         );
//     }

//     if (error) {
//         return <p className="text-center text-red-500">Error: {error}</p>;
//     }

//     if (!form) {
//         return <p className="text-center">Form not found.</p>;
//     }

//     return (
//         <div className="bg-gray-100 dark:bg-gray-900 h-full p-2" style={{ backgroundColor: "#DFDBE5", backgroundImage: "data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.4'%3E%3Cpath d='M50 50c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10zM10 10c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10c0 5.523-4.477 10-10 10S0 25.523 0 20s4.477-10 10-10zm10 8c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zm40 40c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E" }}>

//             {/* notification compo */}
//             {notification && (
//                 <Notification message={notification} onClose={() => setNotification(null)} />
//             )}

//             <form
//                 ref={formRef}
//                 onSubmit={handleSubmit}
//                 className="p-4 sm:p-6 md:p-8 max-w-4xl mx-auto"
//             >
//                 <h1 className="text-2xl font-bold mb-4">{form.form_name}</h1>
//                 <div className="mt-4 space-y-4">
//                     {memoizedFields}
//                 </div>
//                 <button
//                     type="submit"
//                     className="mt-6 px-6 py-2 bg-blue-500 text-white font-bold rounded shadow hover:bg-blue-600">
//                     Submit
//                 </button>
//             </form>
//         </div>
//     );
// });

// export default FormRender;

import React, { useEffect, useState, useMemo, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForms } from "../../contexts/FormsContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import axios from "axios";
import Notification from "../../components/UI/Notification";
import { getToken } from "../../utils/tokenUtils";

const FormRender = React.memo(() => {
  const { id } = useParams();
  // const { forms, fetchForms, loading, error } = useForms();
  const { fetchInternalForms, internalForms, error } = useForms();
  const [form, setForm] = useState(null);
  const [responses, setResponses] = useState({});
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const token = getToken();

  useEffect(() => {
    const loadForm = async () => {
      try {
        setLoading(true);
        const existingForm = internalForms?.find(
          (form) => form.id === parseInt(id, 10),
        );
        if (existingForm) {
          setLoading(false);
          processForm(existingForm);
        } else {
          const fetchedForms = await fetchInternalForms();
          if (fetchedForms === "Authentication required.") navigate("/");
          const fetchedForm = fetchedForms.find(
            (form) => form.id === parseInt(id, 10),
          );
          if (fetchedForm) {
            setLoading(false);
            processForm(fetchedForm);
          } else {
            setLoading(false);
            console.warn("Form not found.");
          }
        }
      } catch (error) {
        console.error("Error loading internal form:", error);
        if (error.message === "Authentication required") {
          navigate("/");
        } else {
          setNotification("Something went wrong while loading the form.");
        }
      }
    };

    loadForm();
  }, [id, internalForms, navigate]);

  // Process form and initialize responses
  const processForm = (rawForm) => {
    const updatedFields = rawForm.fields.map((field, index) => ({
      id: index + 1,
      label: field.label,
      name: field.name,
      description: field.description,
      type: field.type,
      placeholder: field.placeholder,
      image_url: field.image_url,
      showDivider: field.showDivider,
      options: field.options || [],
      conditions: field.conditions || {},
      required: field.required || false,
      maxRating: field.maxRating || 5, // For rating
      min: field.min || 0, // For sliders
      max: field.max || 100, // For sliders
      step: field.step || 1, // For sliders
    }));
    setForm({ ...rawForm, fields: updatedFields });
    initializeResponses(updatedFields);
  };

  const initializeResponses = (fields) => {
    const initialResponses = fields.reduce((acc, field) => {
      acc[field.id] = field.type === "checkboxes" ? [] : "";
      return acc;
    }, {});
    setResponses(initialResponses);
  };

  const updateFieldResponse = (fieldId, value) => {
    setResponses((prevResponses) => ({
      ...prevResponses,
      [fieldId]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("form_id", form.id);
    formData.append("form_name", form.form_name);

    form.fields.forEach((field) => {
      const response = responses[field.id];
      if (field.type === "file-upload" && response instanceof File) {
        formData.append(field.name, response);
      } else {
        formData.append(field.name, response || "");
      }

      // 2. If the selected option has conditions, append those too
      const selectedOption = response;
      const condition = field.conditions?.[selectedOption];

      if (condition?.enabled) {
        condition.fields.forEach((condField) => {
          const compositeKey = `${field.id}_${selectedOption}_${condField.field_name}`;
          const condResponse = responses[compositeKey];

          formData.append(condField.field_name, condResponse || "");
        });
      }
    });

    try {
      const response = await axios.post(
        `https://hrmsnew.prepstripe.com/apid}/form-submission`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      // console.log("form submitted")
      // console.log(response)
      setNotification("Form submitted successfully!");
      // Reset form responses
      initializeResponses(form.fields);
      // reset file field as well
      formRef.current.reset();
    } catch (error) {
      setNotification("Failed to submit the form. Please try again.");
      // reset file field as well
      formRef.current.reset();
    }
  };

  // Render inputs dynamically based on field type
  const renderFieldInput = (field) => {
    switch (field.type) {
      case "form-header":
        return (
          <div className="mb-8 text-center">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              {field.label}
            </h2>
            {field.showDivider && (
              <hr className="my-4 border-t-2 border-gray-300 dark:border-gray-600 mx-auto " />
            )}
            <p className="text-lg text-gray-600 dark:text-gray-300">
              {field.description}
            </p>
          </div>
        );
      case "image":
        return field.image_url ? (
          <div className="flex flex-col items-center mb-8">
            <img
              src={field.image_url}
              alt={field.alt_text || "Form image"}
              className="w-full object-cover max-h-48 rounded-2xl shadow border"
            />
            {field.alt_text && (
              <p className="text-gray-500 text-sm mt-2">{field.alt_text}</p>
            )}
          </div>
        ) : (
          <div className="text-gray-400 italic text-center">
            No image provided
          </div>
        );
      case "short-answer":
        return (
          <input
            type="text"
            value={responses[field.id] || ""}
            placeholder={field.placeholder || "Enter text"}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
            required={field.required}
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
          />
        );
      case "number":
        return (
          <input
            type="number"
            value={responses[field.id] || ""}
            placeholder={field.placeholder || "Enter number"}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
            required={field.required}
            min={0}
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
          />
        );
      case "mobile":
        return (
          <input
            type="tel"
            value={responses[field.id] || ""}
            placeholder={field.placeholder || "Enter mobile number"}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
            required={field.required}
            min={0}
            maxLength={10}
            pattern="[0-9]{10}"
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
          />
        );
      case "phone":
        return (
          <input
            type="tel"
            value={responses[field.id] || ""}
            placeholder={field.placeholder || "Enter phone number"}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
            required={field.required}
            min={0}
            pattern="^[0-9]{6,15}$"
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
          />
        );
      case "email":
        return (
          <input
            type="email"
            value={responses[field.id] || ""}
            placeholder={field.placeholder || "Enter email address"}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
            required={field.required}
            min={0}
            pattern="^[\\w-.]+@([\\w-]+\\.)+[\\w-]{2,4}$"
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
          />
        );
      case "long-answer":
        return (
          <textarea
            value={responses[field.id] || ""}
            placeholder={field.placeholder || "Enter detailed response"}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none resize-vertical min-h-[120px]"
            rows="4"
            required={field.required}
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
          />
        );
      case "radio":
        return (
          <div className="space-y-3">
            {field.options.map((option, idx) => (
              <div
                key={`${field.id}-radio-${idx}`}
                className="flex items-center"
              >
                <input
                  type="radio"
                  name={`radio-${field.id}`}
                  id={`radio-${field.id}-${idx}`}
                  value={option}
                  required={field.required}
                  checked={responses[field.id] === option}
                  onChange={() => updateFieldResponse(field.id, option)}
                  className="w-4 h-4 text-blue-600 border-2 border-gray-300 focus:ring-blue-500 focus:ring-2"
                />
                <label
                  htmlFor={`radio-${field.id}-${idx}`}
                  className="ml-3 text-gray-700 cursor-pointer hover:text-gray-900 transition-colors"
                >
                  {option}
                </label>
              </div>
            ))}
          </div>
        );
      case "checkboxes":
        return (
          <div className="space-y-3">
            {field.options.map((option, idx) => (
              <div
                key={`${field.id}-checkbox-${idx}`}
                className="flex items-center"
              >
                <input
                  type="checkbox"
                  id={`checkbox-${field.id}-${idx}`}
                  value={option}
                  required={field.required}
                  checked={responses[field.id]?.includes(option) || false}
                  onChange={(e) => {
                    const updatedSelections = e.target.checked
                      ? [...responses[field.id], option]
                      : responses[field.id].filter((opt) => opt !== option);
                    updateFieldResponse(field.id, updatedSelections);
                  }}
                  className="w-4 h-4 text-blue-600 border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                />
                <label
                  htmlFor={`checkbox-${field.id}-${idx}`}
                  className="ml-3 text-gray-700 cursor-pointer hover:text-gray-900 transition-colors"
                >
                  {option}
                </label>
              </div>
            ))}
          </div>
        );
      case "dropdown":
        return (
          <div>
            <select
              value={responses[field.id] || ""}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none bg-white"
              onChange={(e) => {
                updateFieldResponse(field.id, e.target.value);
                // Clear conditional field responses when dropdown value changes
                if (field.conditions) {
                  Object.keys(field.conditions).forEach((option) => {
                    if (field.conditions[option].enabled) {
                      field.conditions[option].fields.forEach((condField) => {
                        updateFieldResponse(
                          `${field.id}_${option}_${condField.field_name}`,
                          "",
                        );
                      });
                    }
                  });
                }
              }}
              required={field.required}
            >
              <option value="" disabled className="text-gray-500">
                Select an option
              </option>
              {field.options.map((option, idx) => (
                <option key={`${field.id}-dropdown-${idx}`} value={option}>
                  {option}
                </option>
              ))}
            </select>

            {/* existing code */}
            {/* Render conditional fields if they exist for the selected option */}
            {/* {field.conditions && field.conditions[responses[field.id]]?.enabled && (
                            <div className="mt-4 ml-4 pl-4 border-l-2 border-blue-200">
                                {field.conditions[responses[field.id]].fields.map((condField, idx) => (
                                    <div key={`cond-${field.id}-${idx}`} className="mb-4">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {condField.field_name}
                                            {condField.required && <span className="text-red-500 ml-1">*</span>}
                                        </label>
                                        <input
                                            type={condField.field_type === 'short-answer' ? 'text' : condField.field_type}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
                                            value={responses[`${field.id}_${responses[field.id]}_${condField.field_name}`] || ''}
                                            onChange={(e) => updateFieldResponse(`${field.id}_${responses[field.id]}_${condField.field_name}`, e.target.value)}
                                            required={condField.required}
                                            placeholder={`Enter ${condField.field_name}`}
                                        />
                                    </div>
                                ))}
                            </div>
                        )} */}

            {field.conditions &&
              field.conditions[responses[field.id]]?.enabled && (
                <>
                  <div className="mt-4 ml-4 pl-4 border-l-2 border-blue-200">
                    {field.conditions[responses[field.id]].fields.map(
                      (condField, idx) => (
                        <div key={`cond-${field.id}-${idx}`} className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            {condField.field_name}
                            {condField.required && (
                              <span className="text-red-500 ml-1">*</span>
                            )}
                          </label>
                          <input
                            type={
                              condField.field_type === "short-answer"
                                ? "text"
                                : condField.field_type
                            }
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
                            value={
                              responses[
                                `${field.id}_${responses[field.id]}_${
                                  condField.field_name
                                }`
                              ] || ""
                            }
                            onChange={(e) =>
                              updateFieldResponse(
                                `${field.id}_${responses[field.id]}_${
                                  condField.field_name
                                }`,
                                e.target.value,
                              )
                            }
                            required={condField.required}
                            placeholder={`Enter ${condField.field_name}`}
                          />
                        </div>
                      ),
                    )}
                  </div>
                </>
              )}
          </div>
        );
      case "date":
        return (
          <input
            type="date"
            value={responses[field.id] || ""}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
            required={field.required}
          />
        );
      case "date-time":
        return (
          <input
            type="datetime-local"
            value={responses[field.id] || ""}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
            required={field.required}
          />
        );
      case "file-upload":
        return (
          <div className="relative">
            <input
              type="file"
              className="w-full px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              onChange={(e) => updateFieldResponse(field.id, e.target.files[0])}
              multiple
              required={field.required}
            />
          </div>
        );
      case "star-rating":
        return (
          <div className="flex gap-1">
            {[...Array(field.maxRating || 5)].map((_, idx) => (
              <span
                key={`${field.id}-rating-${idx}`}
                className={`cursor-pointer text-2xl transition-colors duration-200 hover:scale-110 transform ${
                  (responses[field.id] || 0) > idx
                    ? "text-yellow-400"
                    : "text-gray-300 hover:text-yellow-200"
                }`}
                onClick={() => updateFieldResponse(field.id, idx + 1)}
                required={field.required}
              >
                ★
              </span>
            ))}
            <span className="ml-3 text-sm text-gray-600">
              {responses[field.id]
                ? `${responses[field.id]} out of ${field.maxRating || 5}`
                : "Click to rate"}
            </span>
          </div>
        );
      case "toggle":
        return (
          <label className="flex items-center cursor-pointer">
            <div className="relative">
              <input
                type="checkbox"
                checked={responses[field.id] || false}
                onChange={(e) =>
                  updateFieldResponse(field.id, e.target.checked)
                }
                required={field.required}
                className="sr-only"
              />
              <div
                className={`block w-14 h-8 rounded-full transition-colors duration-200 ${
                  responses[field.id] ? "bg-blue-500" : "bg-gray-300"
                }`}
              ></div>
              <div
                className={`absolute top-1 left-1 bg-white w-6 h-6 rounded-full transition-transform duration-200 ${
                  responses[field.id] ? "transform translate-x-6" : ""
                }`}
              ></div>
            </div>
            <span className="ml-3 text-gray-700">{field.field_name}</span>
          </label>
        );
      case "slider":
        return (
          <div className="space-y-2">
            <input
              type="range"
              min={field.min}
              max={field.max}
              step={field.step}
              value={responses[field.id] || field.min}
              onChange={(e) =>
                updateFieldResponse(field.id, parseInt(e.target.value, 10))
              }
              required={field.required}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
              style={{
                background: `linear-gradient(to right, #3B82F6 0%, #3B82F6 ${
                  (((responses[field.id] || field.min) - field.min) /
                    (field.max - field.min)) *
                  100
                }%, #E5E7EB ${
                  (((responses[field.id] || field.min) - field.min) /
                    (field.max - field.min)) *
                  100
                }%, #E5E7EB 100%)`,
              }}
            />
            <div className="flex justify-between text-sm text-gray-600">
              <span>{field.min}</span>
              <span className="font-medium text-blue-600">
                {responses[field.id] || field.min}
              </span>
              <span>{field.max}</span>
            </div>
          </div>
        );
      case "color-picker":
        return (
          <div className="flex items-center space-x-3">
            <input
              type="color"
              value={responses[field.id] || "#000000"}
              onChange={(e) => updateFieldResponse(field.id, e.target.value)}
              required={field.required}
              className="w-16 h-16 border-2 border-gray-200 rounded-lg cursor-pointer"
            />
            <div className="flex flex-col">
              <span className="text-sm text-gray-600">Selected color:</span>
              <span className="font-mono text-sm font-medium">
                {responses[field.id] || "#000000"}
              </span>
            </div>
          </div>
        );
      case "section":
        return (
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 p-6 rounded-lg">
            <h2 className="text-xl font-bold text-gray-900">
              {field.field_name}
            </h2>
          </div>
        );
      case "secret_token":
        return (
          <input
            type="text"
            value={responses[field.id] || ""}
            placeholder="Secret Token"
            className="w-full p-2 border rounded"
            required={field.required}
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
          />
        );
      case "user_password":
        return (
          <input
            type="password"
            value={responses[field.id] || ""}
            placeholder="Password"
            className="w-full p-2 border rounded"
            required={field.required}
            onChange={(e) => updateFieldResponse(field.id, e.target.value)}
          />
        );
      case "enable_notification":
        return (
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={responses[field.id] || false}
              onChange={(e) => updateFieldResponse(field.id, e.target.checked)}
              required={field.required}
            />
            Enable Notification
          </label>
        );
      case "e_signature":
        return (
          <div className="w-full h-24 border-2 border-dashed rounded-lg flex items-center justify-center text-gray-400">
            E-Signature Box
          </div>
        );
      case "matrix_grid":
        return (
          <div className="w-full border px-2 py-3 rounded-2xl text-gray-400">
            Matrix Grid (Render)
          </div>
        );
      case "repeat_group":
        return (
          <div className="w-full border px-2 py-3 rounded-2xl text-gray-400">
            Repeat Group (Render)
          </div>
        );
      case "linear-scale":
        return (
          <div className="py-4">
            <div className="flex items-center gap-6 mb-4">
              <span className="text-lg font-bold text-gray-600 min-w-[2rem] text-center">
                {field.min || 1}
              </span>
              <div className="flex-1 relative">
                <input
                  type="range"
                  min={field.min || 1}
                  max={field.max || 10}
                  value={responses[field.id] || field.min || 1}
                  onChange={(e) =>
                    updateFieldResponse(field.id, e.target.value)
                  }
                  className="w-full h-3 bg-gray-200 rounded-full appearance-none cursor-pointer slider"
                  required={field.required}
                />
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-3 py-1 rounded-lg text-sm font-bold">
                  {responses[field.id] || field.min || 1}
                </div>
              </div>
              <span className="text-lg font-bold text-gray-600 min-w-[2rem] text-center">
                {field.max || 10}
              </span>
            </div>
          </div>
        );
      default:
        return (
          <p className="text-red-500 bg-red-50 p-3 rounded-lg border border-red-200">
            Unsupported field type: {field.type}
          </p>
        );
    }
  };

  const memoizedFields = useMemo(() => {
    return form?.fields.map((field) => (
      <div
        key={field.id}
        className={`${
          field.type === "image"
            ? ""
            : "bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200"
        }`}
      >
        <label className="block text-lg font-semibold text-gray-800 mb-4">
          {field.type != "form-header" && field.type != "image"
            ? field.label
            : ""}
          {field.required && <span className="text-red-500 ml-1">*</span>}
        </label>
        {renderFieldInput(field)}
      </div>
    ));
  }, [form, responses]);

  if (loading) {
    return (
      <div className="bg-gradient-to-br from-slate-50 to-blue-50 p-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-sm p-8">
            <Skeleton height={60} className="mb-6" />
            <Skeleton height={120} count={5} className="mb-4" />
          </div>
        </div>
      </div>
    );
  }

  if (!form) {
    return (
      <div className="bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center p-6">
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
          <div className="text-gray-400 text-5xl mb-4">📋</div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Form Not Found
          </h2>
          <p className="text-gray-600">
            The form you're looking for doesn't exist or has been removed.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="h-full bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50"
      style={{
        backgroundColor: "#DFDBE5",
        backgroundImage:
          "data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.4'%3E%3Cpath d='M50 50c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10zM10 10c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10c0 5.523-4.477 10-10 10S0 25.523 0 20s4.477-10 10-10zm10 8c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zm40 40c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E",
      }}
    >
      {/* notification compo */}
      {notification && (
        <Notification
          message={notification}
          onClose={() => setNotification(null)}
        />
      )}

      <div className="container mx-auto px-4 py-8">
        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="max-w-4xl mx-auto"
        >
          {/* Form Header */}
          {/* <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 mb-8">
                        <div className="text-center">
                            <h1 className="text-4xl font-bold text-gray-900 mb-2">{form.form_name}</h1>
                            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 mx-auto rounded-full"></div>
                        </div>
                    </div> */}

          {/* Form Fields */}
          <div className="space-y-6">{memoizedFields}</div>

          {/* Submit Button */}
          <div className="mt-10 text-center">
            <button
              type="submit"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold text-lg rounded-xl shadow-lg hover:from-blue-700 hover:to-indigo-700 focus:ring-4 focus:ring-blue-200 transform hover:scale-105 transition-all duration-200"
            >
              <span>Submit Form</span>
              <svg
                className="ml-2 w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                />
              </svg>
            </button>
          </div>
        </form>
      </div>

      {/* Custom CSS for slider styling */}
      <style jsx>{`
        .slider::-webkit-slider-thumb {
          appearance: none;
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: #3b82f6;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        }

        .slider::-moz-range-thumb {
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: #3b82f6;
          cursor: pointer;
          border: none;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
});

export default FormRender;
